import { CHAIN_ALIASES } from "src/wallet-connection/chains";
import { NETWORK } from "../constants";
import BscMainnetAddresses from "./bscMainnet";
import BscTestnetAddresses from "./bscTestnet";

export function getNetworkContractAddresses(network) {
  if (network === NETWORK.BSC_MAINNET) return BscMainnetAddresses;
  else if (network === NETWORK.BSC_TESTNET) return BscTestnetAddresses;
  else throw Error("Invalid Network!");
}

export function getChainContractAddresses(chainId) {
  if (chainId === CHAIN_ALIASES.BSC_MAINNET) return BscMainnetAddresses;
  else if (chainId === CHAIN_ALIASES.BSC_TESTNET) return BscTestnetAddresses;
  else throw Error("Invalid chain!");
}
